import React, { useState } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import Resource from './Resource';
import './Project.css';

const Project = ({ id, dayId, resources, onAddResource, showHeader = true, title }) => {
  const [isAddingResource, setIsAddingResource] = useState(false);
  const [newResourceName, setNewResourceName] = useState('');
  const [newResourceRole, setNewResourceRole] = useState('');

  const { setNodeRef, isOver } = useDroppable({
    id: `project-${id}-day-${dayId}`,
    data: { type: 'project', projectId: id, dayId }
  });

  const handleAddResource = () => {
    if (newResourceName.trim()) {
      onAddResource(dayId, id, newResourceName, newResourceRole);
      setNewResourceName('');
      setNewResourceRole('');
      setIsAddingResource(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddResource();
    } else if (e.key === 'Escape') {
      setIsAddingResource(false);
      setNewResourceName('');
      setNewResourceRole('');
    }
  };

  return (
    <div ref={setNodeRef} className={`project-cell ${isOver ? 'over' : ''}`}>
      {showHeader && title && <div className="project-header">{title}</div>}
      <div className="project-resources">
        <SortableContext 
          items={resources.map(r => r.id)} 
          strategy={verticalListSortingStrategy}
        >
          {resources.map((resource) => (
            <Resource 
              key={resource.id} 
              id={resource.id} 
              name={resource.name} 
              role={resource.role}
              skillLevel={resource.skillLevel}
              isTemp={resource.isTemp}
            />
          ))}
        </SortableContext>
      </div>
      
      {isAddingResource ? (
        <div className="project-add-form">
          <input
            type="text"
            placeholder="Resource name..."
            value={newResourceName}
            onChange={(e) => setNewResourceName(e.target.value)}
            onKeyDown={handleKeyPress}
            className="project-input"
            autoFocus
          />
          <input
            type="text"
            placeholder="Role (optional)..."
            value={newResourceRole}
            onChange={(e) => setNewResourceRole(e.target.value)}
            onKeyDown={handleKeyPress}
            className="project-input"
          />
          <div>
            <button onClick={handleAddResource} className="project-submit-button">
              Add
            </button>
            <button 
              onClick={() => {
                setIsAddingResource(false);
                setNewResourceName('');
                setNewResourceRole('');
              }} 
              className="project-cancel-button"
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <button
          onClick={() => setIsAddingResource(true)}
          className="project-add-button"
        >
          + Add resource
        </button>
      )}
    </div>
  );
};

export default Project;
